import { Nav, Navbar } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { logout } from "../../redux/actions/userActions";
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import FetchAuthFromServer from "../FetchAuthFromServer";
import { useLocation } from "react-router-dom";
import axios from "axios";

const UserLinksComponent = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const userInfo = useSelector((state) => state.userRegisterLogin.userInfo);
  const isAuth = FetchAuthFromServer();
  const [deliveryBook, setDeliveryBook] = useState()

  const adminLinks = [

    {
      title: "Sales Portal",
      link: "/admin/salesOrders",
      access: "isSuperAdmin, isExtSales",
    },
    {
      title: "Sales Notes",
      link: "/admin/salesNotes",
      access: "isSuperAdmin, isExtSales",
    },

    {
      title: "Orders",
      link: "/admin/orders",
      access: "isSuperAdmin,isExtSales,accounts,isSales",
    },

    {
      title: "Quotes",
      link: "/admin/quotes?tab=processingQuotes&pageNum=1",
      access: "isSuperAdmin,accounts,isSales,isExtSales",
    },
    {
      title: "Products",
      link: "/admin/products",
      access: "isSuperAdmin,accounts,isSales,isExtSales",
    },
    {
      title: "Users",
      link: "/admin/users",
      access: "isSuperAdmin,accounts,isSales,isExtSales",
    },
    {
      title: "Companies",
      link: "/admin/deliveryBooks",
      access: "isSuperAdmin,accounts,isSales,isExtSales",
    },
    {
      title: "Suppliers",
      link: "/admin/suppliers",
      access: "isSuperAdmin,accounts,isSales,isExtSales",
    },
    {
      title: "PO Cart",
      link: "/admin/poCart-details",
      access: "isSuperAdmin,accounts,isSales",
    },
    {
      title: "Purchase Order",
      link: "/admin/purchaseOrders",
      access: "isSuperAdmin,accounts,isSales",
    },
    {
      title: "System Checks",
      link: "/admin/checks",
      access: "isSuperAdmin,accounts,isSales",
    },
    {
      title: "Promotions",
      link: "/admin/promotions",
      access: "isSuperAdmin,accounts,isSales",
    },
    {
      title: "Admin Tasks",
      link: "/admin/tasks",
      access: "isSuperAdmin",
    },
    {
      title: "Blogs",
      link: "/admin/blogs",
      access: "isSuperAdmin",
    },
    {
      title: "QBook Connect",
      link: "/admin/qbConnect",
      access: "isSuperAdmin",
    },
    {
      title: "Invoices",
      link: "/admin/invoices",
      access: "isSuperAdmin",
    },
  ];

  const userLinks = [
    // {
    //   title: "Uniforms",
    //   link: "/user/my-uniforms",
    //   access: "all",
    // },
    {
      title: "Orders",
      link: "/user/my-orders",
      access: "all",
    },
    {
      title: "Quotes",
      link: "/user/my-quotes?tab=completedQuotes&pageNum=1",
      access: "all",
    },

    {
      title: "My Profile",
      link: "/user",
      access: "all",
    },
    {
      title: "Change Password",
      link: "/user/password",
      access: "all",
    },
  ];
  const marketingLinks = [
    {
      title: "Analytics",
      link: "/user/analytics",
      access: "isSuperAdmin,isMarketing,isExtSales",
    },
    {
      title: "Posts Track",
      link: "/user/postsTrack",
      access: "isSuperAdmin,isMarketing",
    },
    {
      title: "User Interactions",
      link: "/user/userInteractions",
      access: "isSuperAdmin,isMarketing",
    },
  ];

  const hasAccess = (access) => {
    if (access === "all") return true;
    const roles = access.split(",");
    return roles.some((role) => isAuth[role.trim()]);
  };

  const isPathActive = (path) => {
    return location.pathname.includes(path);
  };

  const getdeliveryBooks = async (email) => {
    const { data } = await axios.get("/api/deliveryBooks/deliveryBook/" + email);
    return data;
  };
  useEffect(() => {
    getdeliveryBooks(userInfo.email)
      .then((data) => {
        setDeliveryBook(data[0])
      }).catch((err) => console.log(err));
  }, [userInfo])

  // console.log(deliveryBook);

  return (
    <>
      <Navbar className="user_side_navBar"
        hidden={!isAuth.isAdmin}>
        <Nav className="flex-column user_side_nav">
          <Nav.Link style={{ color: "black" }} disabled>
            ADMIN:
          </Nav.Link>
          {adminLinks.map((link) => {
            if (hasAccess(link.access)) {
              if (link.title === "Quotes") {
                return (
                  <LinkContainer key={link.title} to={link.link} isActive={() => isPathActive('/admin/quotes')}>
                    <Nav.Link className="user_side_nav_options">
                      {link.title}
                    </Nav.Link>
                  </LinkContainer>
                );
              } else {
                return (
                  <LinkContainer key={link.title} to={link.link}>
                    <Nav.Link className="user_side_nav_options">
                      {link.title}
                    </Nav.Link>
                  </LinkContainer>
                );
              }
            }
            return null;
          })}
        </Nav>
      </Navbar>
      <br hidden={!isAuth.isAdmin} />
      {/* <Navbar className="user_side_navBar">
        <Nav className="flex-column user_side_nav">
          <Nav.Link style={{ color: "black" }} disabled>
            ANALYTICS:
          </Nav.Link>
          {marketingLinks.map((link) => {
            if (hasAccess(link.access)) {
              if (link.title === "ANALYTICS :") {
                return (
                  <Nav.Link
                    key={link.title}
                    style={{ color: "black" }}
                    disabled={true}
                    className="user_side_nav_options"
                  >
                    {link.title}
                  </Nav.Link>
                );
              } else {
                return (
                  <LinkContainer key={link.title} to={link.link}>
                    <Nav.Link className="user_side_nav_options">
                      {link.title}
                    </Nav.Link>
                  </LinkContainer>
                );
              }
            }
            return null;
          })}
        </Nav>
      </Navbar> */}
      <br hidden={!isAuth.isAdmin} />
      <Navbar className="user_side_navBar">
        <Nav className="flex-column user_side_nav">
          <Nav.Link style={{ color: "black" }} disabled>
            MY PROFILE:
          </Nav.Link>
          {userLinks.map((link) => {
            if (hasAccess(link.access)) {
              if (link.title === "Uniforms") {
                if (deliveryBook?.hasUniform === true) {
                  return (
                    <LinkContainer key={link.title} to={link.link}>
                      <Nav.Link className="user_side_nav_options">
                        {link.title}
                      </Nav.Link>
                    </LinkContainer>
                  );
                }
              } else if (link.title === "Quotes") {
                return (
                  <LinkContainer key={link.title} to={link.link} isActive={() => isPathActive('/user/my-quotes')}>
                    <Nav.Link className="user_side_nav_options">
                      {link.title}
                    </Nav.Link>
                  </LinkContainer>
                );
              } else {
                return (
                  <LinkContainer key={link.title} to={link.link}>
                    <Nav.Link className="user_side_nav_options">
                      {link.title}
                    </Nav.Link>
                  </LinkContainer>
                );
              }
            }
            return null;
          })}
          <Nav.Link onClick={() => dispatch(logout())}>Logout</Nav.Link>
        </Nav>
      </Navbar>
      <br />

    </>
  );
};

export default UserLinksComponent;
